import Tippy from '@tippyjs/react';
import {DemoProjectFilter, DemoProjectFilterValue} from '../../../../components/Controls/DemoProjectControl';
import {ValidatedIcon} from '../../../../components/Controls/ValidateControl';
import {StickyHeader} from '../../../../components/Table/TableStyles';
import {EditedParticipation} from '../../../Partner/EditedPartner';
import {Filter} from '../../ParticipationFunctions/Filtering';
import {offsetOneRow, offsetTwoRows, centeredContainerStyle, StateStyledCell} from '../../Styles/ParticipationTableStyles';

export function DemoProjectColumnFilter({filter, updateFilter}: {filter: Filter; updateFilter: (filter: Filter) => void}) {
    return (
        <StickyHeader style={{...offsetTwoRows, ...centeredContainerStyle}}>
            <DemoProjectFilter
                value={filter?.DemoProject ?? DemoProjectFilterValue.Unset}
                onChange={(e) => updateFilter({...filter, DemoProject: e.value})}
            />
        </StickyHeader>
    );
}

export function DemoProjectHeader() {
    return (
        <StickyHeader style={{...offsetOneRow, width: '55px', minWidth: '55px', maxWidth: '55px'}}>
            <Tippy content="Shows which projects are demo projects">
                <span>Demo</span>
            </Tippy>
        </StickyHeader>
    );
}

export function DemoProjectContent({ppn}: {ppn: EditedParticipation}) {
    return (
        <StateStyledCell editStatus={ppn.EditStatus}>
            {ppn.PlantingProject?.DemoProject && <ValidatedIcon />}
        </StateStyledCell>
    );
}
